/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_1004, URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Contratar en Movistar Plus+',
              link: URLS.MOVISTAR_PLUS,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Actualmente no cumples las condiciones para disfrutar de esta oferta.',
          msg: [
            'Es necesario contratar Internet o una tarifa móvil con Movistar para disfrutar de Movistar Plus+ a este precio. Puedes contratar Movistar Plus+ directamente en su web.',
          ],
          errorName: 'producto incompatible',
        },
      },
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Ir a mi perfil',
              link: URLS.MY_PROFILE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Tras revisar tus datos no podemos ofrecerte esta oferta.',
          msg: ['Actualmente ya tienes disponible el acceso a Movistar Plus+ en tu pack. Si no conoces tu usuario o no recuerdas tu clave puedes consultarla en tu perfil del área privada de Movistar.'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Tras revisar tus datos no podemos ofrecerte esta oferta.",
          msg: [
            "O bien no cumples las condiciones de contratación o ya estás dado de alta en el servicio.",
            "Por favor, ponte en contacto con nosotros en el 1004 y un asesor comercial te ayudará.",
          ],
          buttons: [CALL_GENERIC_1004],
          errorName: "error generico",
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
